// communicationServices.js
import createEntityService from './entityServiceFactory';

const service = createEntityService({
    endpoint: '/communications.php',
    idParam: 'communication_id',
    viewAction: 'getCommunicationViews',
    viewReturnKey: 'communicationId',
});

export const markCommunicationAsRead  = (id, userId)              => service.markAsRead(id, userId);
export const fetchCommunications      = (userId, isDirector, hideRead, page, pageSize) => service.fetch(userId, isDirector, hideRead, page, pageSize);
export const getCommunicationViews    = (ids)                     => service.getViews(ids);
export const addCommunication         = (formData)                => service.add(formData);
export const removeCommunication      = (id)                      => service.remove(id);
export const updateCommunication      = (formData)                => service.update(formData);
